enum TrafficEngagementMetric {
    TotalPagesPerVisit = "total_pages_per_visit",
    TotalAvgVisitDuration = "total_avg_visit_duration",
    TotalBounceRate = "total_bounce_rate",
    TotalMonthlyVisitsPerVisitor = "total_monthly_visits_per_visitor",
}

export default TrafficEngagementMetric;
